<template>
  <div class="share">
    <ui-button class="btn--share" icon="share" iconPosition="top" size="s" text>
      Partager
    </ui-button>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
export default {
  components: { UiButton },
  props: {
    recipe: { type: Object },
  },
};
</script>
